const actions = {
    FETCH_SUB_CLUBS: 'FETCH_SUB_CLUBS',
    FETCH_SUB_CLUB: 'FETCH_SUB_CLUB',
    RESET_SUB_CLUB: 'RESET_SUB_CLUB',

    fetchSubClubsAction: (data) => {
        return {
            type: actions.FETCH_SUB_CLUBS,
            data: data
        };
    },
    resetSubClubFormAction: () => {
        return {
            type: actions.RESET_SUB_CLUB,
            data: null
        };
    },
    fetchSubClubAction: (data) => {
        return {
            type: actions.FETCH_SUB_CLUB,
            data: data
        };
    },
};

export default actions;